const contentful = require('contentful');

export const client = contentful.createClient({
  space: 'hal1sayc3tet',
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
  host: process.env.REACT_APP_CONTENTFUL_HOST
});

// include param means how many nested entries deep to include in the response
// e.g. in FAQ nested entries are FAQ page -> category -> question & answer ->
// entries embedded in rich text
// the top level is included by default so to include all of the above,
// set include to 3
export const getEntriesByContentTypeAndProduct = (contentType, product, include) => {
  return client
    .getEntries({
      content_type: contentType,
      'fields.product': product,
      include
    })
    .then((res) => res.items)
    .catch((err) => {
      throw err;
    });
};

export const getEntryByContentTypeAndProduct = (contentType, product, include) => {
  return client
    .getEntries({
      content_type: contentType,
      'fields.product': product,
      include
    })
    .then((res) => res.items[0])
    .catch((err) => {
      throw err;
    });
};

export const getEntryByContentType = (contentType) => {
  return client
    .getEntries({
      content_type: contentType
    })
    .then((res) => res.items[0])
    .catch((err) => {
      throw err;
    });
};

export const getEntryByQuery = (query) => {
  return client
    .getEntries(query)
    .then(({ items }) => {
      if (items.length === 0) throw Error('Not found');
      return items[0];
    })
    .catch((err) => {
      throw err;
    });
};
